import { generalConstants } from '../_constants';

const generalReducer = (state = {}, action) => {
  switch (action.type) {
    case generalConstants.GET_COLOR_LIST_SUCCESS:
      return {
        ...state,
        [action.payload.type]: action.payload.data
      };
    case generalConstants.GET_COLOR_LIST_FAILURE:
      return state;
    case generalConstants.CLEAR_COLOR_LIST:
      return {
        ...state,
        [action.payload.type]: action.payload.data
      };
    default:
      return state;
  }
};

export default generalReducer;
